import Vue from 'vue';
import VueFilter from 'vue-filter';

// Init Vue plugins.
Vue.use(VueFilter);

// Register editor component of the admin side.
Vue.component('canvas--editor-admin', require('./editor/Admin').default);
Vue.component('icon-input', require('./../../resources/js/editor/website/editors/inputs/IconInput').default);